import missionTasksActions from './mission.tasks.actions';
import groupMissionTasksActions from './group.mission.tasks.actions';

export default {
  ...missionTasksActions,
  ...groupMissionTasksActions
};
